import {strings} from "@atttomyx/shared-utils";

export const isImage = (value) => value && strings.contains(value, "data:image/png;base64");
